import axios from "axios";
import { useState, useEffect } from "react";
import { Logs } from "../App";
import DialogPaper from "../components/DialogPaper";
import ErrorButton from "../components/ErrorButton";
import Table from "../components/Table";

import ProfileMenu from "../components/ProfileMenu";

export function Home() {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [index, setIndex] = useState(0);

  const treatedData = (res: Logs[]) => {
    const data: any = [];
    res?.forEach((log: Logs, index: number) => {
      let alertText;

      switch (log.alert_level) {
        case 1:
          alertText = "Básico";
          break;
        case 2:
          alertText = "Moderado";
          break;
        case 3:
          alertText = "Crítico";
          break;
        default:
          alertText = "Indefinido";
          break;
      }
      data.push({
        user: log.user_login,
        appVersion: log.app_version,
        server: log.server_url,
        systemVersion: log.system_version,
        phoneModel: log.phone_model,
        error: (
          <ErrorButton setIndex={setIndex} index={index} setOpen={setOpen} />
        ),
        errorDetails: log?.error ?? null,
        userDetails: log?.user_details ?? null,
        deviceDetails: log?.device_details ?? null,
        conectionDetails: log?.conection_details ?? null,
        localizationDetails: log?.localization_details ?? null,
        alert: alertText,
        createdAt: log?.createdAt,
      });
    });

    return data;
  };

  useEffect(() => {
    setLoading(true);
    axios({
      method: "get",
      url: `https://bk-logs.syncplatform.com.br/api/GetLogs`,
      withCredentials: false,
    })
      .then((res) => {
        setData(treatedData(res.data.logs));
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);
  return (
    <>
      <ProfileMenu />
      <Table data={data} isLoading={loading} />
      <DialogPaper open={open} setOpen={setOpen} data={data[index]} />
    </>
  );
}
